import { useCallback, ChangeEvent } from 'react'
import styled from 'styled-components'

import ChevronDown from 'components/icons/ChevronDown2'
import { SelectField as BaseSelectField } from 'components/form'

const SelectField = styled(BaseSelectField)`
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border: 0;

  select {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xs']?.['font-size']?.value};
    font-family: inherit;
    border-radius: 6px;

    &:focus {
      outline: 2px solid ${({ theme }) => theme?.['-ds-core-400']?.value};
    }
  }

  span {
    padding: 0 14px;

    svg {
      width: 20px;
      height: auto;
    }
  }
`

type SelectProps = {
  value: string
  type: string
  options: {
    name: string
    code: string
  }[]
  onFilterChange: (type: string, value: string | number) => any
}

const SelectLocation = ({
  value,
  type,
  options,
  onFilterChange,
}: SelectProps) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      onFilterChange(type, e.target.value)
    },
    [type],
  )

  return (
    <div className="qa-home-search">
      <SelectField rounded>
        &nbsp;
        {options.length > 0 && (
          <select
            value={value}
            onChange={handleChange}
            aria-label="Select location"
            name="location"
          >
            {options?.map(({ code, name }) => (
              <option key={code} value={code}>
                {name}
              </option>
            ))}
          </select>
        )}
        <span>
          <ChevronDown />
        </span>
      </SelectField>
    </div>
  )
}

export default SelectLocation
